import { useState, useRef } from 'react';
import { Menu, MenuItem, ListItemIcon, Radio, Button } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { COLORS } from '../../../utils/Application_Constants';

const FILTER_OPTIONS = ['All', 'Comments', 'Updates'];

const ActivityFeedFilter = ({ selectedFilter, setSelectedFilter }) => {
    const [openModal, setOpenModal] = useState(false);
    const anchorRef = useRef(null);

    const handleClick = () => {
        setOpenModal(true);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const handleSelect = (option) => {
        setSelectedFilter(option);
        handleClose();
    };

    const FilterIcon = selectedFilter === 'All' ? FilterAltOutlinedIcon : FilterAltIcon;

    return (
        <>
            <Button
                variant="text"
                color="primary"
                sx={{
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: COLORS.LT_JOURNEY,
                    },
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    paddingInline: '0px',
                }}
                onClick={handleClick}
                ref={anchorRef}
            >
                <FilterIcon fontSize="14px" sx={{ mr: 0.5 }} />
                Filter
            </Button>

            <Menu
                anchorEl={anchorRef.current}
                open={openModal}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                disableScrollLock
                PaperProps={{
                    sx: {
                        mt: 1,
                    },
                }}
            >
                {FILTER_OPTIONS.map((option) => (
                    <MenuItem
                        key={option}
                        onClick={() => handleSelect(option)}
                        sx={{
                            paddingY: 0.2,
                            paddingX: 1.5,
                            minHeight: '20px',
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 24 }}>
                            <Radio
                                edge="start"
                                checked={selectedFilter === option}
                                tabIndex={-1}
                                disableRipple
                                size="small"
                            />
                        </ListItemIcon>
                        {option}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default ActivityFeedFilter;
